function isFunction<T, U>(value: ((arg: U) => T) | T): value is (arg: U) => T {
    return typeof value === 'function';
}

export const parseOptionsValuesOrFunc = <T, U>(fn: ((arg: U) => T) | T, arg: U): T => (isFunction(fn) ? fn(arg) : fn);
